<template>
	<li :class="styles.air__menuLeft__category">
		<span>{{ item.title }}</span>
	</li>
</template>

<script>
/* eslint-disable vue/require-default-prop */

export default {
	name: 'Category',
	props: {
		item: Object,
		styles: Object,
	},
};
</script>
